import { useEffect, useRef, useState } from 'react'
import './DateRangeFilter.css'
import { DateRangePicker, defaultStaticRanges } from 'react-date-range'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import dayjs from 'dayjs'

type Props = {
  id: string
  onChange: (id: string, value: string) => void
}

export const DEFAULT_START_DATE = dayjs().utc().subtract(3, 'month').toDate()
export const DEFAULT_END_DATE = dayjs().utc().add(1, 'day').toDate()

const DateRangeFilter: React.FC<Props> = ({ id, onChange }) => {
  // date range state
  const [range, setRange] = useState([
    {
      startDate: DEFAULT_START_DATE,
      endDate: DEFAULT_END_DATE,
      key: 'selection',
    },
  ])

  const [startTimeId, endTimeId] = id.split(',')

  // open close calendar
  const [open, setOpen] = useState(false)

  // get target element to toggle
  const refOne = useRef(null)

  useEffect(() => {
    document.addEventListener('click', hideOnClickOutside, true)
  }, [])

  // hide date picker when click outside component
  const hideOnClickOutside = (event: any) => {
    const clickTarget: any = refOne.current
    if (clickTarget && !clickTarget.contains(event.target)) {
      setOpen(false)
    }
  }

  // set date range in store
  const handleSetRange = (selection: any) => {
    setRange([selection])
    const start = dayjs(selection.startDate).utc().format('YYYY-MM-DD')
    const end = dayjs(selection.endDate).utc().format('YYYY-MM-DD')
    onChange(startTimeId, start)
    onChange(endTimeId, end)
  }

  return (
    <div className='calender-wrap'>
      <input
        value={` ${dayjs(range[0].startDate).format('YYYY-MM-DD')} to ${dayjs(range[0].endDate).format('YYYY-MM-DD')} `}
        readOnly
        className='input-box'
        onClick={() => setOpen((open) => !open)}
      />
      <div ref={refOne}>
        {open && (
          <DateRangePicker
            onChange={(item) => {
              handleSetRange(item.selection)
            }}
            editableDateInputs={true}
            moveRangeOnFirstSelection={false}
            ranges={range}
            months={1}
            direction='horizontal'
            inputRanges={[]}
            staticRanges={[
              ...defaultStaticRanges,
              {
                label: "All Time",
                range: () => ({
                  startDate: new Date("2019-01-01"),
                  endDate: new Date()
                }),
                isSelected(range) {
                  if (!(range.startDate && range.endDate)) return false
                  return (range.startDate <= new Date("2019-01-01")) || (range.endDate >= new Date());
                }
              }
            ]}
            className='calender-element'
          />
        )}
      </div>
    </div>
  )
}

export default DateRangeFilter
